import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderTrakingModel, OrderTrakingPutModel } from '../model/order-traking.model';
import { OrderTrackingServiceRest } from './order-tracking.service-rest';



@Injectable()
export class OrderTrackingService {

  constructor(private serviceRest: OrderTrackingServiceRest) { }

  getTrakingService(page: number = 0, param: string, filterOrderStatesSelected: string, registerLimite: boolean): Observable<OrderTrakingModel> {
    return this.serviceRest.getTrakingService(page, param, filterOrderStatesSelected, registerLimite);
  }

  getOrdersByAccountIdService(accountId: string): Observable<OrderTrakingModel> {
    return this.serviceRest.getOrdersByAccountIdService(accountId);
  }

  createContato(contato: OrderTrakingModel): Observable<any> {
    return this.createContato(contato);
  }

  updateTrakingService(id: string): Observable<OrderTrakingPutModel> {
    return this.serviceRest.updateTrakingService(id);
  }

  deleteContato(id: string): Observable<any> {
    return this.deleteContato(id);
  }

  getHomeManager(param: string): Observable<OrderTrakingModel[]> {
    return this.serviceRest.getHomeManager(param);
  }

}
